import { useEffect } from "react";

const BASE_URL = "https://livius-training.co.uk";

/**
 * Usage: <BreadcrumbSchema items={[{name: "Home", url: "/"}, {name: "First Aid", url: "/FirstAid"}]} />
 */
export default function BreadcrumbSchema({ items }) {
  useEffect(() => {
    if (!items || items.length === 0) return;

    const existing = document.getElementById("structured-data-breadcrumb");
    if (existing) existing.remove();

    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name,
        "item": `${BASE_URL}${item.url}`
      }))
    };

    const script = document.createElement("script");
    script.id = "structured-data-breadcrumb";
    script.type = "application/ld+json";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById("structured-data-breadcrumb");
      if (el) el.remove();
    };
  }, [items]);

  return null;
}